"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SellCarFetchDTO = exports.SellCarOptionsDTO = exports.SellCarFilterDTO = exports.SellCarRequestResponseDTO = exports.SellCarRequestUpdateDTO = exports.ExchangeCarRequestCreateDTO = exports.SellCarRequestCreateDTO = exports.SellCarRequestDTO = exports.VehicleOption = exports.TradeInOption = exports.RequestType = void 0;
const class_validator_1 = require("class-validator");
const class_transformer_1 = require("class-transformer");
const class_transformer_2 = require("class-transformer");
const global_1 = require("../../../../global");
const vehicle_1 = require("../../../vehicle");
var RequestType;
(function (RequestType) {
    RequestType["SELL"] = "sell";
    RequestType["TRADE_IN"] = "trade_in";
})(RequestType = exports.RequestType || (exports.RequestType = {}));
var TradeInOption;
(function (TradeInOption) {
    TradeInOption["YES"] = "yes";
    TradeInOption["NO"] = "no";
})(TradeInOption = exports.TradeInOption || (exports.TradeInOption = {}));
var VehicleOption;
(function (VehicleOption) {
    VehicleOption["NEW"] = "new";
    VehicleOption["USED"] = "used";
})(VehicleOption = exports.VehicleOption || (exports.VehicleOption = {}));
class SellCarRequestDTO {
    validate() {
        const errors = (0, class_validator_1.validateSync)(this);
        return errors.map((error) => { var _a; return Object.values((_a = error.constraints) !== null && _a !== void 0 ? _a : {}); }).flat();
    }
    static fromPlain(plain) {
        return (0, class_transformer_1.plainToClass)(SellCarRequestDTO, plain);
    }
    toPlain() {
        return (0, class_transformer_1.classToPlain)(this);
    }
}
__decorate([
    (0, class_validator_1.IsUUID)(),
    __metadata("design:type", String)
], SellCarRequestDTO.prototype, "id", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], SellCarRequestDTO.prototype, "name", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsPhoneNumber)(),
    __metadata("design:type", String)
], SellCarRequestDTO.prototype, "phone", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], SellCarRequestDTO.prototype, "brand", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], SellCarRequestDTO.prototype, "brandName", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], SellCarRequestDTO.prototype, "model", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], SellCarRequestDTO.prototype, "modelName", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], SellCarRequestDTO.prototype, "modelVersion", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], SellCarRequestDTO.prototype, "modelVersionName", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], SellCarRequestDTO.prototype, "year", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], SellCarRequestDTO.prototype, "mileage", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], SellCarRequestDTO.prototype, "description", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], SellCarRequestDTO.prototype, "specification", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], SellCarRequestDTO.prototype, "specificationName", void 0);
__decorate([
    (0, class_validator_1.IsEnum)(TradeInOption),
    __metadata("design:type", String)
], SellCarRequestDTO.prototype, "tradeIn", void 0);
__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsString)({ each: true }),
    __metadata("design:type", Array)
], SellCarRequestDTO.prototype, "images", void 0);
__decorate([
    (0, class_validator_1.IsBoolean)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Boolean)
], SellCarRequestDTO.prototype, "isDeleted", void 0);
__decorate([
    (0, class_validator_1.IsDate)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Date)
], SellCarRequestDTO.prototype, "createdAt", void 0);
__decorate([
    (0, class_validator_1.IsDate)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Date)
], SellCarRequestDTO.prototype, "updatedAt", void 0);
exports.SellCarRequestDTO = SellCarRequestDTO;
class SellCarRequestCreateDTO {
    validate() {
        const errors = (0, class_validator_1.validateSync)(this);
        return errors.map((error) => { var _a; return Object.values((_a = error.constraints) !== null && _a !== void 0 ? _a : {}); }).flat();
    }
    static fromPlain(plain) {
        return (0, class_transformer_1.plainToClass)(SellCarRequestCreateDTO, plain);
    }
    toPlain() {
        return (0, class_transformer_1.classToPlain)(this);
    }
}
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    __metadata("design:type", String)
], SellCarRequestCreateDTO.prototype, "name", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsPhoneNumber)(),
    __metadata("design:type", String)
], SellCarRequestCreateDTO.prototype, "phone", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], SellCarRequestCreateDTO.prototype, "brand", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], SellCarRequestCreateDTO.prototype, "brandName", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], SellCarRequestCreateDTO.prototype, "model", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], SellCarRequestCreateDTO.prototype, "modelName", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], SellCarRequestCreateDTO.prototype, "modelVersion", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], SellCarRequestCreateDTO.prototype, "modelVersionName", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], SellCarRequestCreateDTO.prototype, "year", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], SellCarRequestCreateDTO.prototype, "mileage", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Number)
], SellCarRequestCreateDTO.prototype, "expectedSellingPrice", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], SellCarRequestCreateDTO.prototype, "description", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], SellCarRequestCreateDTO.prototype, "emirates", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], SellCarRequestCreateDTO.prototype, "specification", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], SellCarRequestCreateDTO.prototype, "specificationName", void 0);
__decorate([
    (0, class_validator_1.IsEnum)(RequestType),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], SellCarRequestCreateDTO.prototype, "requestType", void 0);
__decorate([
    (0, class_validator_1.IsEnum)(TradeInOption),
    __metadata("design:type", String)
], SellCarRequestCreateDTO.prototype, "tradeIn", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], SellCarRequestCreateDTO.prototype, "additionalDetails", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Number)
], SellCarRequestCreateDTO.prototype, "dealDriveEstimation", void 0);
__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsString)({ each: true }),
    __metadata("design:type", Array)
], SellCarRequestCreateDTO.prototype, "images", void 0);
__decorate([
    (0, class_validator_1.ValidateNested)({ each: true }),
    (0, class_transformer_2.Type)(() => vehicle_1.VehicleMediaCreateDTO),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Array)
], SellCarRequestCreateDTO.prototype, "media", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsDateString)(),
    __metadata("design:type", Date)
], SellCarRequestCreateDTO.prototype, "inspectionBookingDate", void 0);
exports.SellCarRequestCreateDTO = SellCarRequestCreateDTO;
class ExchangeCarRequestCreateDTO {
    validate() {
        const errors = (0, class_validator_1.validateSync)(this);
        return errors.map((error) => { var _a; return Object.values((_a = error.constraints) !== null && _a !== void 0 ? _a : {}); }).flat();
    }
    static fromPlain(plain) {
        return (0, class_transformer_1.plainToClass)(SellCarRequestCreateDTO, plain);
    }
    toPlain() {
        return (0, class_transformer_1.classToPlain)(this);
    }
}
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    __metadata("design:type", String)
], ExchangeCarRequestCreateDTO.prototype, "name", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsPhoneNumber)(),
    __metadata("design:type", String)
], ExchangeCarRequestCreateDTO.prototype, "phone", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], ExchangeCarRequestCreateDTO.prototype, "brand", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], ExchangeCarRequestCreateDTO.prototype, "brandName", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], ExchangeCarRequestCreateDTO.prototype, "model", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], ExchangeCarRequestCreateDTO.prototype, "modelName", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], ExchangeCarRequestCreateDTO.prototype, "modelVersion", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], ExchangeCarRequestCreateDTO.prototype, "modelVersionName", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], ExchangeCarRequestCreateDTO.prototype, "year", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], ExchangeCarRequestCreateDTO.prototype, "mileage", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Number)
], ExchangeCarRequestCreateDTO.prototype, "expectedSellingPrice", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], ExchangeCarRequestCreateDTO.prototype, "description", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], ExchangeCarRequestCreateDTO.prototype, "emirates", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], ExchangeCarRequestCreateDTO.prototype, "specification", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], ExchangeCarRequestCreateDTO.prototype, "specificationName", void 0);
__decorate([
    (0, class_validator_1.IsEnum)(RequestType),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], ExchangeCarRequestCreateDTO.prototype, "requestType", void 0);
__decorate([
    (0, class_validator_1.IsEnum)(TradeInOption),
    __metadata("design:type", String)
], ExchangeCarRequestCreateDTO.prototype, "tradeIn", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], ExchangeCarRequestCreateDTO.prototype, "additionalDetails", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Number)
], ExchangeCarRequestCreateDTO.prototype, "dealDriveEstimation", void 0);
__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsString)({ each: true }),
    __metadata("design:type", Array)
], ExchangeCarRequestCreateDTO.prototype, "images", void 0);
__decorate([
    (0, class_validator_1.ValidateNested)({ each: true }),
    (0, class_transformer_2.Type)(() => vehicle_1.VehicleMediaCreateDTO),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Array)
], ExchangeCarRequestCreateDTO.prototype, "media", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsDateString)(),
    __metadata("design:type", Date)
], ExchangeCarRequestCreateDTO.prototype, "bookingDate", void 0);
exports.ExchangeCarRequestCreateDTO = ExchangeCarRequestCreateDTO;
class SellCarRequestUpdateDTO {
    validate() {
        const errors = (0, class_validator_1.validateSync)(this);
        return errors.map((error) => { var _a; return Object.values((_a = error.constraints) !== null && _a !== void 0 ? _a : {}); }).flat();
    }
    static fromPlain(plain) {
        return (0, class_transformer_1.plainToClass)(SellCarRequestUpdateDTO, plain);
    }
    toPlain() {
        return (0, class_transformer_1.classToPlain)(this);
    }
}
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], SellCarRequestUpdateDTO.prototype, "name", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsPhoneNumber)(),
    __metadata("design:type", String)
], SellCarRequestUpdateDTO.prototype, "phone", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsEmail)(),
    __metadata("design:type", String)
], SellCarRequestUpdateDTO.prototype, "email", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], SellCarRequestUpdateDTO.prototype, "city", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsEnum)(RequestType),
    __metadata("design:type", String)
], SellCarRequestUpdateDTO.prototype, "requestType", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsUUID)(),
    __metadata("design:type", String)
], SellCarRequestUpdateDTO.prototype, "makeId", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsUUID)(),
    __metadata("design:type", String)
], SellCarRequestUpdateDTO.prototype, "modelId", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsPositive)(),
    __metadata("design:type", Number)
], SellCarRequestUpdateDTO.prototype, "year", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsPositive)(),
    __metadata("design:type", Number)
], SellCarRequestUpdateDTO.prototype, "mileage", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], SellCarRequestUpdateDTO.prototype, "specification", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsString)({ each: true }),
    __metadata("design:type", Array)
], SellCarRequestUpdateDTO.prototype, "images", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsUUID)(),
    __metadata("design:type", String)
], SellCarRequestUpdateDTO.prototype, "desiredVehicleId", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], SellCarRequestUpdateDTO.prototype, "color", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], SellCarRequestUpdateDTO.prototype, "transmission", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], SellCarRequestUpdateDTO.prototype, "fuelType", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], SellCarRequestUpdateDTO.prototype, "engineCapacity", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], SellCarRequestUpdateDTO.prototype, "description", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsEnum)([
        "pending",
        "inspection_scheduled",
        "inspected",
        "valued",
        "approved",
        "rejected",
        "completed",
    ]),
    __metadata("design:type", String)
], SellCarRequestUpdateDTO.prototype, "status", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Object)
], SellCarRequestUpdateDTO.prototype, "additionalDetails", void 0);
exports.SellCarRequestUpdateDTO = SellCarRequestUpdateDTO;
class SellCarRequestResponseDTO {
    validate() {
        const errors = (0, class_validator_1.validateSync)(this);
        return errors.map((error) => { var _a; return Object.values((_a = error.constraints) !== null && _a !== void 0 ? _a : {}); }).flat();
    }
    static fromPlain(plain) {
        return (0, class_transformer_1.plainToClass)(SellCarRequestResponseDTO, plain);
    }
    toPlain() {
        return (0, class_transformer_1.classToPlain)(this);
    }
}
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], SellCarRequestResponseDTO.prototype, "id", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], SellCarRequestResponseDTO.prototype, "refId", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    __metadata("design:type", String)
], SellCarRequestResponseDTO.prototype, "name", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsPhoneNumber)(),
    __metadata("design:type", String)
], SellCarRequestResponseDTO.prototype, "phone", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], SellCarRequestResponseDTO.prototype, "brand", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], SellCarRequestResponseDTO.prototype, "brandName", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], SellCarRequestResponseDTO.prototype, "model", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], SellCarRequestResponseDTO.prototype, "modelName", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], SellCarRequestResponseDTO.prototype, "modelVersion", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], SellCarRequestResponseDTO.prototype, "modelVersionName", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], SellCarRequestResponseDTO.prototype, "year", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], SellCarRequestResponseDTO.prototype, "mileage", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], SellCarRequestResponseDTO.prototype, "expectedSellingPrice", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], SellCarRequestResponseDTO.prototype, "description", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], SellCarRequestResponseDTO.prototype, "specification", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], SellCarRequestResponseDTO.prototype, "specificationName", void 0);
__decorate([
    (0, class_validator_1.IsEnum)(RequestType),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], SellCarRequestResponseDTO.prototype, "requestType", void 0);
__decorate([
    (0, class_validator_1.IsEnum)(TradeInOption),
    __metadata("design:type", String)
], SellCarRequestResponseDTO.prototype, "tradeIn", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Number)
], SellCarRequestResponseDTO.prototype, "dealDriveEstimation", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], SellCarRequestResponseDTO.prototype, "additionalDetails", void 0);
__decorate([
    (0, class_validator_1.IsBoolean)(),
    __metadata("design:type", Boolean)
], SellCarRequestResponseDTO.prototype, "isDeleted", void 0);
__decorate([
    (0, class_validator_1.IsBoolean)(),
    __metadata("design:type", Boolean)
], SellCarRequestResponseDTO.prototype, "isActive", void 0);
__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsString)({ each: true }),
    __metadata("design:type", Array)
], SellCarRequestResponseDTO.prototype, "images", void 0);
__decorate([
    (0, class_validator_1.ValidateNested)({ each: true }),
    (0, class_transformer_2.Type)(() => vehicle_1.VehicleMediaCreateDTO),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Array)
], SellCarRequestResponseDTO.prototype, "media", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Object)
], SellCarRequestResponseDTO.prototype, "createdById", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Object)
], SellCarRequestResponseDTO.prototype, "updatedById", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Object)
], SellCarRequestResponseDTO.prototype, "deletedById", void 0);
exports.SellCarRequestResponseDTO = SellCarRequestResponseDTO;
class SellCarFilterDTO {
    validate() {
        const errors = (0, class_validator_1.validateSync)(this);
        return errors.map((error) => { var _a; return Object.values((_a = error.constraints) !== null && _a !== void 0 ? _a : {}); }).flat();
    }
    static fromPlain(plain) {
        return (0, class_transformer_1.plainToClass)(SellCarFilterDTO, plain);
    }
    toPlain() {
        return (0, class_transformer_1.classToPlain)(this);
    }
}
__decorate([
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], SellCarFilterDTO.prototype, "search", void 0);
__decorate([
    (0, class_validator_1.IsUUID)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], SellCarFilterDTO.prototype, "leadId", void 0);
__decorate([
    (0, class_validator_1.IsBoolean)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Boolean)
], SellCarFilterDTO.prototype, "isActive", void 0);
__decorate([
    (0, class_validator_1.IsObject)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", global_1.DateFilter)
], SellCarFilterDTO.prototype, "createdAt", void 0);
__decorate([
    (0, class_validator_1.IsEnum)(TradeInOption),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], SellCarFilterDTO.prototype, "tradeIn", void 0);
exports.SellCarFilterDTO = SellCarFilterDTO;
class SellCarOptionsDTO extends global_1.PaginationOptions {
    static fromPlain(plain) {
        return (0, class_transformer_1.plainToClass)(SellCarOptionsDTO, plain);
    }
    toPlain() {
        return (0, class_transformer_1.classToPlain)(this);
    }
}
__decorate([
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Object)
], SellCarOptionsDTO.prototype, "sort", void 0);
exports.SellCarOptionsDTO = SellCarOptionsDTO;
class SellCarFetchDTO {
    validate() {
        const errors = (0, class_validator_1.validateSync)(this);
        return errors.map((error) => { var _a; return Object.values((_a = error.constraints) !== null && _a !== void 0 ? _a : {}); }).flat();
    }
    static fromPlain(plain) {
        return (0, class_transformer_1.plainToClass)(SellCarFetchDTO, plain);
    }
    toPlain() {
        return (0, class_transformer_1.classToPlain)(this);
    }
}
exports.SellCarFetchDTO = SellCarFetchDTO;
